import { render } from "./SldDiy.vue?vue&type=template&id=a9cfd594&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=a9cfd594&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cfd594"]])

export default __exports__